import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AutorizacionService } from './autorizacion.service';
import { Autorizacion, Permisos, RolUsuario } from './autorizacion.models';

@Directive({
  selector: '[permisos]',
  standalone: false,
})
export class PermisosDirective implements OnInit {
  @Input({ required: true }) permisos!: Permisos | undefined;

  constructor(
    private autorizacionService: AutorizacionService,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.viewContainer.clear();
    if (this.permisos === undefined) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    const autorizacion: Autorizacion = { permisos: this.permisos };
    this.autorizacionService.tieneAutorizacion$(autorizacion).then((tieneAutorizacion) => {
      if (tieneAutorizacion) this.viewContainer.createEmbeddedView(this.templateRef);
    });
  }
}

@Directive({
  selector: '[roles]',
  standalone: false,
})
export class RolesDirective implements OnInit {
  @Input({ required: true }) roles: RolUsuario[] | undefined;

  constructor(
    private autorizacionService: AutorizacionService,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.viewContainer.clear();
    if (this.roles === undefined || this.roles.length === 0) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.autorizacionService.tieneRol$(this.roles).then((tieneRol) => {
      if (tieneRol) this.viewContainer.createEmbeddedView(this.templateRef);
    });
  }
}

@Directive({
  selector: '[autorizacion]',
  standalone: false,
})
export class AutorizacionDirective implements OnInit {
  @Input({ required: true }) autorizacion: Autorizacion | undefined;

  constructor(
    private autorizacionService: AutorizacionService,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit() {
    this.viewContainer.clear();
    if (this.autorizacion === undefined) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.autorizacionService.tieneAutorizacion$(this.autorizacion).then((tieneAutorizacion) => {
      if (tieneAutorizacion) this.viewContainer.createEmbeddedView(this.templateRef);
    });
  }
}
